import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers } from "./../../../component/common/AparEmployeeHeader";
import { getPersonalAttributeMasterList, getPersonalAttributeGrade, savePersonalAttributeGrade, updatePersonalAttributeGrade } from "./../../../actions/AppraisalCycleAction";

class aparReportingManagerForm3 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      reportingAssessmentId: null,
      kpiTotal: null,
      hasExistingGrades: false,
      isSubmitted: false,
      personalAttributes: [] as any[],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Personal Attributes Assessment - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { reportingAssessmentId, kpiReportId, kpiTotal, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, kpiReportId, reportingAssessmentId, kpiTotal, showLoader: true });

    // Fetch master attributes first, then existing grades
    getPersonalAttributeMasterList().then((res: any) => {
      const masterList = res?.result || res || [];
      const sorted = [...masterList].sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
      const personalAttributes = sorted.map((m: any) => ({
        attributeMasterId: m.id,
        name: m.attribute_name,
        sortOrder: m.sort_order,
        grade: '',
      }));

      this.setState({ personalAttributes }, () => {
        if (kpiReportId) {
          this.loadExistingGrades(kpiReportId);
        } else {
          this.setState({ showLoader: false });
        }
      });
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  }

  loadExistingGrades = (kpiReportId: any) => {
    getPersonalAttributeGrade({ kpiReportId, gradedByRole: "reporting" }).then((res: any) => {
      const data = res?.result || res;
      const grades = data?.grades || (Array.isArray(data) ? data : []);

      if (grades.length > 0) {
        const gradeMap: any = {};
        grades.forEach((g: any) => {
          gradeMap[g.attribute_master_id] = g;
        });

        const personalAttributes = this.state.personalAttributes.map((attr: any) => {
          const existing = gradeMap[attr.attributeMasterId];
          if (existing) {
            return { ...attr, grade: String(existing.grade || '') };
          }
          return attr;
        });

        this.setState({ personalAttributes, hasExistingGrades: true, isSubmitted: !!data?.is_submitted, showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleAttributeChange = (index: number, value: string) => {
    let grade = parseFloat(value) || 0;
    if (grade > 10) grade = 10;
    if (grade < 0) grade = 0;
    const clampedValue = grade > 0 ? String(grade) : value;
    const personalAttributes = [...this.state.personalAttributes];
    personalAttributes[index] = { ...personalAttributes[index], grade: clampedValue };
    this.setState({ personalAttributes });
  };

  calculateTotalAttributes = () => {
    return this.state.personalAttributes.reduce((sum: number, a: any) => sum + (parseFloat(a.grade) || 0), 0);
  };

  calculateOverallGrading = () => {
    const total = this.calculateTotalAttributes();
    return (total / 4).toFixed(2);
  };

  validateForm = () => {
    const { personalAttributes } = this.state;
    for (let i = 0; i < personalAttributes.length; i++) {
      if (!personalAttributes[i].grade || parseFloat(personalAttributes[i].grade) <= 0) {
        alert(`Please enter a grade for "${personalAttributes[i].name}".`);
        return false;
      }
    }
    return true;
  };

  buildAttrPayload = () => {
    const { kpiReportId, personalAttributes } = this.state;
    return {
      kpiReportId,
      gradedByRole: "reporting",
      grades: personalAttributes.map((a: any) => ({
        attributeMasterId: a.attributeMasterId,
        grade: parseFloat(a.grade) || 0,
      })),
    };
  };

  callAttrApi = (callback: () => void) => {
    const { kpiReportId, hasExistingGrades } = this.state;
    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }
    this.setState({ showLoader: true });
    const payload = this.buildAttrPayload();
    const apiCall = hasExistingGrades ? updatePersonalAttributeGrade(payload) : savePersonalAttributeGrade(payload);
    apiCall.then(() => {
      this.setState({ showLoader: false, hasExistingGrades: true });
      callback();
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callAttrApi(() => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    const { employeeData, kpiReportId, reportingAssessmentId, kpiTotal } = this.state;
    const overallGrading = parseFloat(this.calculateOverallGrading()) || 0;

    this.callAttrApi(() => {
      this.props.history.push({
        pathname: CONSTANT.component.aparReportingManagerForm4.url,
        state: {
          ...employeeData,
          kpiReportId,
          reportingAssessmentId,
          kpiTotal,
          overallGrading,
        },
      });
    });
  };

  render() {
    const { showLoader, employeeData, personalAttributes, isSubmitted } = this.state;

    const ROMAN = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Reporting Authority - Assessment</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="reporting" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This assessment has been submitted and is now view-only.
                  </div>
                )}

                {!showLoader && (
                  <div>
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-3">
                      Assessment of Personal Attributes and Functional Competencies
                    </h2>

                    <p className="text-muted mb-3">
                      Grades should be assigned on a scale of <strong>1-10</strong>, in maximum of <strong>2 decimal numbers</strong>, with <strong>10</strong> referring to the best grade and <strong>1</strong> to the lowest grade. Weightage to this Section will be <strong>25%</strong>.
                    </p>

                    <div className="table-responsive mb-2">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: '10%' }}>S.No.</th>
                            <th style={{ width: '60%' }}>Personal Attributes and Functional Competencies</th>
                            <th style={{ width: '30%' }}>Grade by Reporting Authority</th>
                          </tr>
                        </thead>
                        <tbody>
                          {personalAttributes.map((attr: any, index: number) => (
                            <tr key={attr.attributeMasterId}>
                              <td>{ROMAN[index] || index + 1}</td>
                              <td>{attr.name}</td>
                              <td>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="1"
                                  max="10"
                                  value={attr.grade}
                                  onChange={(e) => this.handleAttributeChange(index, e.target.value)}
                                  className="form-control form-control-sm text-center"
                                  placeholder="0.00"
                                  required
                                  disabled={isSubmitted}
                                />
                              </td>
                            </tr>
                          ))}
                          <tr className="table-light fw-semibold">
                            <td colSpan={2} className="text-end pe-3">Total (i to x)</td>
                            <td className="text-center">{this.calculateTotalAttributes().toFixed(2)}</td>
                          </tr>
                          <tr className="table-secondary fw-bold">
                            <td colSpan={2} className="text-end pe-3">Overall Grading (Total / 4)</td>
                            <td className="text-center">{this.calculateOverallGrading()}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="text-muted mt-3 mb-3">
                      <p className="mb-1"><strong>a.</strong> Personal Attributes and Functional Competencies should be judged in the backdrop of Leadership ability to lead by example, particularly in challenging circumstances.</p>
                      <p className="mb-0"><strong>b.</strong> Item nos. (iv) and (v) on the team work should be evaluated based on the ability of the incumbent to perform as a member of a team and enhance team performance.</p>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      {!isSubmitted && (
                        <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save Draft"}
                        </button>
                      )}
                      {!isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save & Next"} <i className="fa fa-arrow-right ml-1" />
                        </button>
                      )}
                      {isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={() => {
                          const { employeeData, kpiReportId, reportingAssessmentId, kpiTotal } = this.state;
                          this.props.history.push({
                            pathname: CONSTANT.component.aparReportingManagerForm4.url,
                            state: { ...employeeData, kpiReportId, reportingAssessmentId, kpiTotal, overallGrading: parseFloat(this.calculateOverallGrading()) || 0 },
                          });
                        }}>
                          Next <i className="fa fa-arrow-right ml-1" />
                        </button>
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparReportingManagerForm3);
